'use client';

import { Button } from '@modules/common/components/button';
import { useRouter } from 'next/navigation';
import { useState } from 'react';

export default function GoBackButton() {
  const router = useRouter();
  const [isPending, setIsPending] = useState(false);

  return (
    <Button
      variant="secondary"
      size="lg"
      isLoading={isPending}
      onClick={() => {
        setIsPending(true);
        router.back();
      }}
    >
      Go back
    </Button>
  );
}
